"use client";

import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "@/lib/utils";
import { TOOLTIP_COLLISION_PADDING } from "@/common/constants";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef(
    (
        {
            className,
            sideOffset = 4,
            collisionPadding = TOOLTIP_COLLISION_PADDING,
            ...props
        },
        ref
    ) => (
        <TooltipPrimitive.Portal>
            <TooltipPrimitive.Content
                ref={ref}
                sideOffset={sideOffset}
                collisionPadding={collisionPadding}
                className={cn(
                    // bg-primary/px-3 colisionan con utilities de Bootstrap/CoreUI (usan !important
                    // con otro valor); se usan arbitrarios para que el nombre de clase no coincida.
                    "z-[10001] overflow-hidden rounded-md bg-[#171717] px-[0.75rem] py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-tooltip-content-transform-origin]",
                    className
                )}
                {...props}
            />
        </TooltipPrimitive.Portal>
    )
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
